module.exports = __webpack_public_path__ + "img/Azurity_Search_Blur_600.471b1f91.webp";